module.exports = __webpack_public_path__ + "img/_video_full_screen.dee89ca8.svg";